import { ws } from "../../utils/common";

export const getUserSessionStatsWS = async ({ type, start, end }) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "user/session/",
    { type, start, end },
    null,
    true
  );

  if (res.error) {
    throw res.data.message;
  } else {
    return res.data;
  }
};
